import { combineReducers } from 'redux';
import paymentIntent from './paymentIntent';
import paymentStatus from './paymentStatus';
import cardholderVerification from './cardholderVerification';

export default combineReducers({
  paymentIntent,
  paymentStatus,
  cardholderVerification
});
